import Vuex, { createStore } from 'vuex';
import se from './modules/se'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    se,
  },
  strict: debug
});
